<template>
  <div>
    <div class="vx-row" id="inviterecord">
      <div class="vx-col w-full mb-base flex" v-if="inviteHistory.length !== 0">
        <vx-card
          class="pb-5"
          title="Email Invite History"
          v-if="inviteHistory.length > 0"
        >
          <vs-table search :data="inviteHistory" stripe>
            <template slot="thead">
              <vs-th>Date & Time</vs-th>
              <vs-th>To Address</vs-th>
              <vs-th>Sent via</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].dateSent">
                  <span v-if="data[indextr].dateSent < timeNowS">
                    {{ formatTimeStamp(data[indextr].dateSent) }}
                  </span>
                  <span v-else>
                    Scheduled for {{ formatTimeStamp(data[indextr].dateSent) }}
                  </span>
                </vs-td>
                <vs-td :data="data[indextr].to">
                  {{ data[indextr].to }}
                </vs-td>
                <vs-td :data="data[indextr].triggeredBy">
                  {{
                    data[indextr].triggeredBy
                      ? data[indextr].triggeredBy !== "Developer API" &&
                        data[indextr].triggeredBy !== "Zapier"
                        ? "Dashboard"
                        : data[indextr].triggeredBy
                      : "Dashboard"
                  }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div clas="w-full" v-if="hasMoreInvites">
            <vs-button
              :disabled="invitesLoading"
              class="block mt-10 mx-auto"
              @click="getInvites(false)"
              type="border"
              >Load more</vs-button
            >
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full mb-base flex" v-else>No invites sent yet.</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasMoreInvites: false,
      invitesLoading: false,
      timeNowS: false
    };
  },
  computed: {
    inviteHistory() {
      return this.$store.state.dash.viewData.emailInviteRecord;
    },
  },
  methods: {
    getInvites(initial = false) {
      this.invitesLoading = true;

      let startAfter = false;
      if (!initial) {
        //pass the id of last record:
        startAfter = this.inviteHistory[this.inviteHistory.length - 1].id;
      }

      console.log("getting more..");
      console.log(startAfter);

      this.$store
        .dispatch("dash/SYNC_INVITE_SENT_HISTORY", {
          type: "email",
          startAfter,
        })
        .then((hasMore) => {
          this.hasMoreInvites = hasMore;
          this.invitesLoading = false;
        })
        .catch((e) => {
          this.invitesLoading = false;
        });
    }
  },
  mounted() {
        this.getInvites(true);
        this.timeNowS = Math.floor((new Date()).getTime() / 1000);            
    }
};
</script>
